import options from './autocomplete.component';

export default {
    selector: 'dtLabelsAutocomplete',
    options
};



// WEBPACK FOOTER //
// ./app/common/labels-autocomplete/index.js